<div id="mainComponentContainer">
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="accountHeadings" :data="creditAccounts" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onAccountActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button id="exportAsExcelBtn" class="btn btn-primary" @click="downloadCompanyCreditAccounts">
                                    Export as Excel
                                </button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label for="customerDropdown">Customer</label>
                                        <select class="form-control" id="customerDropdown" v-model="filter.selectedCustomerId">
                                            <option value="">All Customers</option>
                                            <option v-for="customer in customers" :key="customer.companyId" :value="customer.companyId">
                                                {{customer.registeredCompanyName}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-6">
                                        <label for="paymentTermDropdown">Payment Terms</label>
                                        <select class="form-control" id="paymentTermDropdown" v-model="filter.selectedPaymentTypeId">
                                            <option value="">All Payment Terms</option>
                                            <option v-for="paymentType in paymentTypes" :key="paymentType.paymentTypeId" :value="paymentType.paymentTypeId">
                                                {{paymentType.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <!-- Suspend Company Confirmation Modal -->
    <confirm-delete-modal
        :elementId="suspendModal.modalId"
        :message="suspendModal.message"
        :showModal="suspendModal.showModal"
        :loading="suspendModal.loading"
        :modalTitle="suspendModal.title"
        @deleteConfirmed="onSuspendConfirmed"></confirm-delete-modal>
</div>
